export const cbCreateButtonLabel: string = "Add Office";
